import {ref, watch, watchEffect} from 'vue'
import request from "@/service/request";
import {
    getAddressTree,
    getProjectColdColumn,
    getProjectColdList,
    getProjectIncrementColumn,
    getProjectIncrementList,
    getProjectStockColumn,
    getProjectStockList
} from "@/service/api";

let mapTime = localStorage.getItem('mapTime')
export let searchType = ref('gbccl');
export let developer = ref("");
export let checkboxs = ref([]);
export let checkList = ref([]);
export let checkAll = ref(false);
export let tableData = ref([]);
export let total = ref(0)

export let formData = ref({
    quarter: [],
    address: [],
    provCode: '',
    cityCode: '',
    areaCode: '',
    startDate: '',
    endData: '',
    minVacancyRate: '',
    maxVacancyRate: '',
    minEffectiveRent: '',
    maxEffectiveRent: '',
    rptBuildingTypeNames: '',
    date: [],
})
export let pagination = ref({
    pageSize: 20,
    pageNum: 1,
})

let column = ref({
    stock: [],
    increment: [],
    clod: [],
})

watch(pagination, () => {
    getTableData()
}, {immediate: true, deep: true})

let getColumn = async () => {
    let {data: data1} = await request({
        url: getProjectStockColumn,
    })

    let {data: data2} = await request({
        url: getProjectIncrementColumn,
    })
    let {data: data3} = await request({
        url: getProjectColdColumn,
    })
    checkboxs.value = data1
    column.value.stock = data1 || []
    column.value.increment = data2 || []
    column.value.clod = data3 || []
}


export async function getTableData() {
    const {date, address} = formData.value
    let params = {
        ...formData.value,
        ...pagination.value,
        startDate: date.length ? date[0] : '',
        endData: date.length ? date[1] : '',
        provCode: address[0] ? address[0] : '',
        cityCode: address[1] ? address[1] : '',
        areaCode: address[2] ? address[2] : '',
        selectedColumns: [...checkList.value],

    }
    delete params.address
    delete params.date
        let data = await request({
            url: searchType.value === 'lk' ? getProjectColdList : searchType.value === 'gbczl' ? getProjectIncrementList : getProjectStockList,
            method: 'post',
            data: {
               ...params,
            }
        })
        tableData.value = data.rows || []
        total.value = data.total

    }

    watch(searchType, (val) => {

    })


    export const changeSearchType = (type) => {
        if (type === searchType.value) return;

        searchType.value = type;
        if (type == 'gbccl') {
            checkboxs.value = column.value.stock;
        } else if (type == 'gbczl') {
            checkboxs.value = column.value.increment;
        } else if (type == 'lk') {
            checkboxs.value = column.value.clod;
        }
        checkAll.value = false;
        checkList.value = [];
        reset()
    }

    export const handleCheckAllChange = (flag) => {
        checkList.value = flag ? checkboxs.value.map(item => {
            return item.name;
        }) : [];
    }

    export const handleCheckItemChange = () => {
        checkAll.value = checkList.value.length == checkboxs.value.length;
    }

    export const reset = () => {
        formData.value = {
            quarter: [],
            address: [],
            provCode: '',
            cityCode: '',
            areaCode: '',
            startDate: '',
            endData: '',
            minVacancyRate: '',
            maxVacancyRate: '',
            minEffectiveRent: '',
            maxEffectiveRent: '',
            rptBuildingTypeNames: '',
            date: [],
        }
        pagination.value = {
            pageSize: 20,
            pageNum: 1,
        }
        // getTableData()
    }

    export const search = () => {
        getTableData()
    }
    export let headerInfo = ref({
        provinces: [],
        quarter: []
    })
// 获取省市区地址
    const getTree = async () => {
        let {data} = await request({
            url: getAddressTree,
            data: {
                filterateaear: false
            }
        })
        headerInfo.value = {
            provinces: data.provinces || [],
            quarter: data.quarter || []
        }
        getTableData();
    }


    export const init = () => {
        getColumn()
        getTree()
    }